import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import {
    AlertBanner,
    Button,
    Markdown,
    Modal,
    ModalBody,
    Text,
} from "@wojo/ui";
import dayjs from "dayjs";
import { useState } from "react";
import { useTripBuilder } from "../context/TripBuilderContext";
import { DepartureStatus } from "../../../../generated/graphql";

export const LowDpdPriceMessage: React.FC = () => {
    const { departure } = useTripBuilder();
    const { productPage } = useI18n("productPage");
    const [modalIsOpen, setModalIsOpen] = useState(false);

    if (!departure) {
        return null;
    }
    const { status, departureDate, autoApproveDeadline } = departure;

    const autoApprovedDpdCutoff = dayjs(departureDate).diff(
        dayjs(autoApproveDeadline),
        "days",
    );
    const lowDpdPriceMessage =
        productPage.tripBuilder.quote.lowDpdPrice?.alert.l({
            dpd: autoApprovedDpdCutoff.toString(),
        });
    const modalMarkdown =
        productPage.tripBuilder.quote.lowDpdPrice?.modalMarkdown.l({
            dpd: autoApprovedDpdCutoff.toString(),
        });
    const cta = productPage.tripBuilder.quote.lowDpdPrice?.cta.l();

    if (!lowDpdPriceMessage || status !== DepartureStatus.OnRequest) {
        return null;
    }

    return (
        <>
            <AlertBanner status="info">
                {lowDpdPriceMessage}{" "}
                {modalMarkdown && cta ? (
                    <Button
                        type="button"
                        variant="quiet"
                        style={{
                            display: "flex",
                            marginTop: "var(--g-spacing-xs)",
                        }}
                        onClick={() => {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "MODAL_OPENED",
                                    modalId: "Additional Costs",
                                },
                            });
                            setModalIsOpen(true);
                        }}
                    >
                        {cta}
                    </Button>
                ) : null}
            </AlertBanner>
            {modalMarkdown ? (
                <Modal
                    accessibleTitle={lowDpdPriceMessage}
                    isOpen={modalIsOpen}
                    onCloseRequested={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "MODAL_CLOSED",
                                modalId: "Additional Costs",
                            },
                        });
                        setModalIsOpen(false);
                    }}
                >
                    <ModalBody>
                        <Text.Heading
                            order="4"
                            tag="h1"
                            style={{ marginBottom: "var(--g-spacing-sm)" }}
                        >
                            {lowDpdPriceMessage}
                        </Text.Heading>
                        <Markdown markdown={modalMarkdown} />
                    </ModalBody>
                </Modal>
            ) : null}
        </>
    );
};
